import { useQuery } from 'react-query'
import request from '../../../request'
import { useDealership } from '../../../../store/zustand/dealershipStore'

export const useGetInventoryAlerts = () => {
  const dealership = useDealership()
  return useQuery(
    ['dealership', dealership?.id, 'inventory', 'analysis', 'stats', 'alerts'],
    ({ signal }) =>
      request<{
        vehicles_with_no_price?: number
        vehicles_with_no_image?: number
      }>({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/inventory/stats/alerts`,
        method: 'GET',
        signal,
      }).then((res: any) => res.data),
    {
      enabled: !!dealership?.id,
      keepPreviousData: true,
    },
  )
}
